
import { defineComponent } from "vue";

export default defineComponent({
    data() {
        return {
            agentMessage: "",
        };
    },
    watch: {
        message() {
            this.updatedAgentMessage();
        },
    },
    props: {
        isError: {
            type: Boolean,
            required: false
        },
        message: {
            type: String,
            required: true
        },
    },
    mounted() {
        this.updatedAgentMessage();
    },
    methods: {
        updatedAgentMessage() {
            this.agentMessage = this.message;
        },
        onTryAgainClicked() {
            this.$emit("tryAgainClicked");
        }
    },
});
